module.exports = __webpack_public_path__ + "index/img/gonggao.ca5d5a44.png";